/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PharmacyCounselorAnswer,
  PharmacyCounselorAnswerFromJSON,
  PharmacyCounselorAnswerFromJSONTyped,
  PharmacyCounselorAnswerToJSON,
  PharmacyCounselorQuestionnaire,
  PharmacyCounselorQuestionnaireFromJSON,
  PharmacyCounselorQuestionnaireFromJSONTyped,
  PharmacyCounselorQuestionnaireToJSON,
} from "./";

export const PharmacyCounselorFollowUpTypename = "PharmacyCounselorFollowUp" as const;

/**
 *
 * @export
 * @interface PharmacyCounselorFollowUp
 */
export interface PharmacyCounselorFollowUp {
  /**
   *
   * @type {Date}
   * @memberof PharmacyCounselorFollowUp
   */
  answeredTime?: string;
  /**
   *
   * @type {Array<PharmacyCounselorAnswer>}
   * @memberof PharmacyCounselorFollowUp
   */
  answers?: Array<PharmacyCounselorAnswer>;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorFollowUp
   */
  followUpType: PharmacyCounselorFollowUpFollowUpTypeEnum;
  /**
   *
   * @type {boolean}
   * @memberof PharmacyCounselorFollowUp
   */
  isNotifyAnswered?: boolean;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorFollowUp
   */
  message?: string;
  /**
   *
   * @type {number}
   * @memberof PharmacyCounselorFollowUp
   */
  notificationPatternId?: number;
  /**
   *
   * @type {Date}
   * @memberof PharmacyCounselorFollowUp
   */
  notificationTime?: string;
  /**
   *
   * @type {number}
   * @memberof PharmacyCounselorFollowUp
   */
  questionnairePatternId?: number;
  /**
   *
   * @type {Array<PharmacyCounselorQuestionnaire>}
   * @memberof PharmacyCounselorFollowUp
   */
  questionnaires?: Array<PharmacyCounselorQuestionnaire>;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorFollowUp
   */
  status: PharmacyCounselorFollowUpStatusEnum;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorFollowUp
   */
  thanksMessage?: string;
  /**
   *
   * @type {Date}
   * @memberof PharmacyCounselorFollowUp
   */
  thanksMessageSentTime?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyCounselorFollowUp
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PharmacyCounselorFollowUpFollowUpTypeEnum {
  Chain = "chain",
  Pharmacy = "pharmacy",
} /**
 * @export
 * @enum {string}
 */
export enum PharmacyCounselorFollowUpStatusEnum {
  Initialized = "initialized",
  Registered = "registered",
  Notified = "notified",
  Answered = "answered",
  AnswerConfirmed = "answer_confirmed",
  Completed = "completed",
  Canceled = "canceled",
}

export function PharmacyCounselorFollowUpFromJSON(json: any): PharmacyCounselorFollowUp {
  return PharmacyCounselorFollowUpFromJSONTyped(json, false);
}

export function PharmacyCounselorFollowUpFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyCounselorFollowUp {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyCounselorFollowUpTypename,

    answeredTime:
      !exists(json, "answered_time") ||
      (typeof json["answered_time"] === "string" && json["answered_time"].substring(0, 4) === "0001")
        ? undefined
        : json["answered_time"],
    answers: !exists(json, "answers")
      ? undefined
      : (json["answers"] as Array<any>).map(PharmacyCounselorAnswerFromJSON),
    followUpType: json["follow_up_type"],
    isNotifyAnswered: !exists(json, "is_notify_answered") ? undefined : json["is_notify_answered"],
    message: !exists(json, "message") ? undefined : json["message"],
    notificationPatternId: !exists(json, "notification_pattern_id") ? undefined : json["notification_pattern_id"],
    notificationTime:
      !exists(json, "notification_time") ||
      (typeof json["notification_time"] === "string" && json["notification_time"].substring(0, 4) === "0001")
        ? undefined
        : json["notification_time"],
    questionnairePatternId: !exists(json, "questionnaire_pattern_id") ? undefined : json["questionnaire_pattern_id"],
    questionnaires: !exists(json, "questionnaires")
      ? undefined
      : (json["questionnaires"] as Array<any>).map(PharmacyCounselorQuestionnaireFromJSON),
    status: json["status"],
    thanksMessage: !exists(json, "thanks_message") ? undefined : json["thanks_message"],
    thanksMessageSentTime:
      !exists(json, "thanks_message_sent_time") ||
      (typeof json["thanks_message_sent_time"] === "string" &&
        json["thanks_message_sent_time"].substring(0, 4) === "0001")
        ? undefined
        : json["thanks_message_sent_time"],
  };
}

export function PharmacyCounselorFollowUpToJSON(object?: PharmacyCounselorFollowUp | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    answered_time: value.answeredTime === undefined ? undefined : tzDate(value.answeredTime).format(),
    answers: value.answers === undefined ? undefined : (value.answers as Array<any>).map(PharmacyCounselorAnswerToJSON),
    follow_up_type: value.followUpType,
    is_notify_answered: value.isNotifyAnswered,
    message: value.message,
    notification_pattern_id: value.notificationPatternId,
    notification_time: value.notificationTime === undefined ? undefined : tzDate(value.notificationTime).format(),
    questionnaire_pattern_id: value.questionnairePatternId,
    questionnaires:
      value.questionnaires === undefined
        ? undefined
        : (value.questionnaires as Array<any>).map(PharmacyCounselorQuestionnaireToJSON),
    status: value.status,
    thanks_message: value.thanksMessage,
    thanks_message_sent_time:
      value.thanksMessageSentTime === undefined ? undefined : tzDate(value.thanksMessageSentTime).format(),
  };
}
